import moment from 'moment';
import 'abortcontroller-polyfill';
import axios from 'axios';
import { GENERAL_CONSTANTS } from '~/constants';

// Terminate fetch
const controller = new AbortController();
const signal = controller.signal;

const _getLanguage = navigator.language || window.navigator.language;
const _getDevice = window.navigator.platform;
let startDateTime = moment();

const requestAbort = () => {
  controller.abort();
  console.log('abort executed');
};

const getBrowser = () => {
  const ua = navigator.userAgent;
  let tem;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: tem[1] || '' };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: 'Opera', version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1],
  };
};

const currentFormatedDate = () => {
  return moment().format(GENERAL_CONSTANTS.DATE_FORMAT);
};

const getExpectedTime = () => {
  const seconds = moment.duration(moment().diff(startDateTime)).asSeconds();
  console.log('getExpectedTime:', seconds);
  startDateTime = moment();
  return seconds;
};

const browserInfo = getBrowser();

export const requestData = {
  config: {
    start: eventDataProps.data.start_utc,
    end: eventDataProps.data.end_utc,
    camera_from: eventDataProps.data.main_camera_id ? eventDataProps.data.main_camera_id : 0,
    camera_to: eventDataProps.data.main_camera_id ? eventDataProps.data.main_camera_id : 0,
  },
  postData: {
    event_id: eventDataProps.data.id,
    room_id: eventDataProps.data.room_id,
    venue_id: eventDataProps.data.venue.id,
    organization_id: eventDataProps.data.venue.organization_id,
    event_code: eventDataProps.data.venue.event_code,
    event_status: eventDataProps.data.status,
    event_flag: eventDataProps.data.flag,
    local_datetime: currentFormatedDate(),
    venue_timezone: eventDataProps.data.venue.timezone_id,
    event_country_code: eventDataProps.data.venue.country,
    new_viewer: eventDataProps.data.venue.new_viewer,
    force_registration: eventDataProps.data.venue.force_registration,
    commercial_links: eventDataProps.data.venue.commercial_link,
    unique_url: analytic_data.data.unique_url,
    ip4: analytic_data.data.ip4,
    uuid: analytic_data.data.uuid,
    fingerprint_id: analytic_data.data.uuid,
    position: 0,
    admin_user: 0,
    language: _getLanguage,
    browser: browserInfo.name + ' ' + browserInfo.version,
    device: analytic_data.data.device,
  },
};

// configUpate
export const setConfig = (nextConfig) => {
  // update reqest data
  // merge prev config and next config
  requestData.config = { ...requestData.config, ...nextConfig };
};

export const setPostData = (newData) => {
  requestData.postData = { ...requestData.postData, ...newData };
};

// rest
export const rest = (INFO) => {
  const analyticsURL = ENV.ANALYTICS_API_URL;
  if (analyticsURL) {
    axios
      .post(analyticsURL, {
        data: INFO.postData,
      })
      .then(function (response) {
        // console.log(response);
      })
      .catch(function (error_message) {
        // console.log('Analytic Error:', error_message);
      });
  } else {
    return false;
  }
};

export const init = (prevCam, nextCam) => {
  console.log('Analyctis init');

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'init';
  info.postData.report = 'general';

  return rest(info);
};

export const streaming = (prevCam, nextCam) => {
  console.log('Analyctis streaming');
  startDateTime = moment();

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'streaming';
  info.postData.report = 'general';
  return rest(info);
};

export const stop = (prevCam, nextCam) => {
  console.log('Analyctis stop');

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'stop';
  info.postData.report = 'general';
  return rest(info);
};

export const pause = (prevCam, nextCam) => {
  console.log('Analyctis pause');

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'pause';
  info.postData.report = 'general';
  return rest(info);
};

export const mute = (volume, prevCam, nextCam) => {
  console.log('Analyctis mute');
  const action = volume ? 'mute' : 'unmute';

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = action;
  info.postData.report = 'general';
  return rest(info);
};

export const fullscreen = (fullscreen, prevCam, nextCam) => {
  console.log('Analyctis fullscreen');
  const action = fullscreen ? 'on-fullscreen' : 'off-fullscreen';

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = action;
  info.postData.report = 'general';
  return rest(info);
};

export const camera = (prevCam, nextCam) => {
  console.log('Analyctis camera', prevCam, nextCam);

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'camer'; // this is intentionally mispelled so don't correct it.
  info.postData.report = 'general';
  return rest(info);
};

export const seek = (prevCam, nextCam, position, offset) => {
  console.log('Analyctis seek');

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.seek_position = position;
  info.postData.seek_offset = offset;
  info.postData.action = 'seek';
  info.postData.report = 'general';
  return rest(info);
};

export const error = (prevCam, nextCam, message) => {
  console.log('Analyctis error');

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.error_message = message;
  info.postData.action = 'error';
  info.postData.report = 'general';
  return rest(info);
};

export const buffer = (prevCam, nextCam) => {
  console.log('Analyctis buffer');

  const info = {};
  info.postData = requestData.postData;
  info.postData.seconds = getExpectedTime();
  info.postData.camera_from = prevCam;
  info.postData.camera_to = nextCam;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'buff';
  info.postData.report = 'general';
  // return rest(info);
};

export const commercialClick = (element, page, eventStatus) => {
  console.log('Analyctis commercialClick', element, page, eventStatus);

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'commercial_click';
  info.postData.element = element;
  info.postData.page = page;
  info.postData.event_status = eventStatus;
  info.postData.report = 'click';
  return rest(info);
};

export const preNeedClick = (element, page, eventStatus) => {
  console.log('Analyctis preNeedClick', element, page, eventStatus);

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'preneed_click';
  info.postData.element = element;
  info.postData.page = page;
  info.postData.event_status = eventStatus;
  info.postData.report = 'click';
  return rest(info);
};

export const preNeedFormExist = (element, page, eventStatus) => {
  console.log('Analyctis preNeedFormExist', element, page, eventStatus);

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'preneed_exit';
  info.postData.element = element;
  info.postData.page = page;
  info.postData.event_status = eventStatus;
  info.postData.report = 'click';
  return rest(info);
};

export const preNeedFormSubmit = (element, page, eventStatus) => {
  console.log('Analyctis preNeedFormSubmit', page, eventStatus);

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'preneed_submit';
  info.postData.element = element;
  info.postData.page = page;
  info.postData.event_status = eventStatus;
  info.postData.report = 'click';
  return rest(info);
};

export const loadOgrForm = () => {
  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'load-ogr';
  info.postData.report = 'ogr';
  return rest(info);
};

export const submitOgrForm = () => {
  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.action = 'submit-ogr';
  info.postData.report = 'ogr';
  return rest(info);
};

export const openFeedbackForm = () => {
  console.log('Analyctis open Feedback form');

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.has_description = 0;
  info.postData.action = 'open';
  info.postData.report = 'feedback';

  return rest(info);
};

export const closeFeedbackForm = () => {
  console.log('Analyctis close Feedback form');

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.has_description = 0;
  info.postData.action = 'close';
  info.postData.report = 'feedback';

  return rest(info);
};

export const submitFeedbackForm = (hasDescription) => {
  console.log('Analyctis submit Feedback form');

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.has_description = hasDescription;
  info.postData.action = 'submit';
  info.postData.report = 'feedback';

  return rest(info);
};

export const errorFeedbackForm = () => {
  console.log('Analyctis error Feedback form');

  const info = {};
  info.postData = requestData.postData;
  info.postData.local_datetime = currentFormatedDate();
  info.postData.has_description = 0;
  info.postData.action = 'error';
  info.postData.report = 'feedback';

  return rest(info);
};

const Analytics = {
  requestData,
  setConfig,
  setPostData,
  init,
  streaming,
  rest,
  stop,
  pause,
  camera,
  seek,
  mute,
  fullscreen,
  error,
  buffer,
  commercialClick,
  preNeedClick,
  preNeedFormExist,
  preNeedFormSubmit,
  loadOgrForm,
  submitOgrForm,
  openFeedbackForm,
  closeFeedbackForm,
  submitFeedbackForm,
  errorFeedbackForm,
};

export default Analytics;
